import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildSeo, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/portfolio")({
  component: lazyRouteComponent(() => import("@/pages-lazy/portfolio")),
  head: () => {
    const seo = buildSeo({
      title: "أعمالنا | Portfolio — BAZZAR 3D",
      description:
        "استعرض مشاريع بازار ثري دي في التصميم الداخلي والنماذج ثلاثية الأبعاد — فلل، مطاعم، مكاتب، ريتيل، ضيافة، ومساحات تجارية.",
      path: "/portfolio",
      keywords: "معرض أعمال, تصميم داخلي, 3D, portfolio, BAZZAR 3D, مشاريع",
    });
    return {
      meta: seo.meta,
      links: seo.links,
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbJsonLd([
              { name: "Home", path: "/" },
              { name: "Portfolio", path: "/portfolio" },
            ]),
          ),
        },
      ],
    };
  },
});